<ng-container *ngIf="visible">
  <div *ngIf="genBildirimValue.value === 'GenBildirim'" class="panel" id="panel" [ngClass]="{'bildirim-header': genBildirimValue.visible == false}" #panel>
  <ng-container class="main-container">
    <div id="data" #data class="data-wrapper">
      <div class="data-part border default-background">
        <div class="tabpanel-demo">
          <div class="content default-card">
            <div class="m-3">

              <dx-toolbar class="mb-4">
                <dxi-item
    location="after"
    locateInMenu="never"
    widget="dxButton"
    [options]="{
      icon: 'close',
      stylingMode: 'contained',
      type: 'danger',
      hint: 'Kapat',
      onClick: handleCancelClick
    }"
  ></dxi-item>
                <dxi-item
    locateInMenu="always"
    widget="dxButton"
    [options]="{
      icon: 'check',
      text: 'Tümünü okundu olarak işaretle',
      stylingMode: 'text',
      onClick: readAllClick
    }"
  ></dxi-item>

  <dxi-item
    locateInMenu="always"
    widget="dxButton"
    [options]="{
      icon: 'trash',
      text: 'Tümünü Sil',
      type: 'danger',
      stylingMode: 'text',
      onClick: deleteAllClick
    }"
  ></dxi-item>
              </dx-toolbar>

              <dx-list
                #listRef
                class="dx-list-f"
                [dataSource]="dataSource"
                selectionMode="single"
                (onSelectionChanged)="onSelectionChanged($event)"
                (onScroll)="handleScroll($event)"
                height="calc(100% - 50px)"
                pageLoadMode="scrollBottom"
              >
                <div *dxTemplate="let item of 'item'">
                  <div
                    class="notification-item"
                    [ngClass]="{
                      read: item.OkunduEh === 'E',
                      unread: item.OkunduEh !== 'E'
                    }"
                    style="cursor: pointer"
                    (click)="oneRead(item)"
                    (dblclick)="openForm(item)"
                  >
                    <div class="icon">
                      <i class="dx-icon dx-icon-{{ item.Icon || 'email' }}"></i>
                    </div>
                    <div class="text">
                      <div class="title">{{ item.Baslik }}</div>
                      <div class="message">{{ item.Metin }}</div>
                      <div class="date">
                        {{ item.KayitTarih | date: 'dd.MM.yyyy HH:mm' }}
                      </div>
                    </div>

                    <dx-button
                      icon="trash"
                      stylingMode="contained"
                      type="danger"
                      (click)="oneDelete(item)"
                    ></dx-button>
                  </div>
                </div>
              </dx-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<div *ngIf="genBildirimValue.value === 'İzin' || genBildirimValue.value === 'Telefon'" class="panel" [ngClass]="{'bildirim-header': genBildirimValue.visible == false}" id="panel" #panel>
  <ng-container class="main-container">
    <div id="data" #data class="data-wrapper">
      <div class="data-part border default-background">
        <div class="tabpanel-demo">
          <div class="content default-card">
            <div class="m-3">
              <dx-toolbar class="mb-4">
                <dxi-item
    location="after"
    locateInMenu="never"
    widget="dxButton"
    [options]="{
      icon: 'close',
      stylingMode: 'contained',
      type: 'danger',
      hint: 'Kapat',
      onClick: handleCancelClick
    }"
  ></dxi-item>
              </dx-toolbar>


<dx-list
  *ngIf="genBildirimValue.value === 'İzin'"
  #listRef
  class="dx-list-f"
  [dataSource]="dataSource"
  selectionMode="single"
  [searchEnabled]="true"
  [grouped]="true"
  (onScroll)="handleScroll($event)"
  height="100%"
>
  <!-- Grup Header -->
  <div *dxTemplate="let group of 'group'">
    <strong>{{ group.key }}</strong>
  </div>

  <!-- Grup içindeki elemanlar -->
  <div *dxTemplate="let itemObj of 'item'">
    <div class="custom-list-item" style="cursor: pointer">
      <div class="image">
        <img
          [src]="itemObj.imageBase64 || 'assets/temp-profile-example.png'"
          alt="Profil Resmi"
          class="personel-avatar"
        />
      </div>
      <div class="text">
        <div class="title">{{ itemObj.PersonelKod }}</div>
        <div class="title">{{ itemObj.AdSoyad }}</div>
        <div class="date">
          <!-- dtokgoz 02.10: eski hâli (saatli)
          {{ itemObj.BaslangicTarih | date:'dd.MM.yyyy HH:mm' }} -
          {{ itemObj.BitisTarih | date:'dd.MM.yyyy HH:mm' }}
          -->
          {{ itemObj.BaslangicTarih | date:'dd.MM.yyyy' }} -
          {{ itemObj.BitisTarih | date:'dd.MM.yyyy' }}
        </div>
        <div class="vekili" *ngIf="itemObj.VekilAdSoyad">
          Vekili: {{ itemObj.VekilAdSoyad }}
        </div>
      </div>
    </div>
  </div>
</dx-list>




              <dx-list
              *ngIf="genBildirimValue.value === 'Telefon'"
                 #listRef
                class="dx-list-f"
                [dataSource]="dataSource"
                selectionMode="single"
                [searchEnabled]="true"
                [grouped]="true"
                 [searchExpr]="['AdiSoyadi','Dahili','TelefonNo']"
                (onScroll)="handleScroll($event)"
                height="100%"
              >
                <div *dxTemplate="let itemObj  of 'item'">
                  <div
                    class="custom-list-item"
                    style="cursor: pointer"
                  >
                    <div class="text">
                      <div class="title">{{ itemObj.AdiSoyadi }}</div>
                      <div class="date">
                        {{ itemObj.Dahili }} - {{ itemObj.TelefonNo }}
                      </div>
                    </div>
                  </div>
                </div>
              </dx-list>




            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<!-- 📄 Sol Detay Panel -->
<div *ngIf="selectedItem && genBildirimValue.value === 'Duyuru'" class="duyuru-floating-panel">
  <dx-button
    icon="close"
    stylingMode="contained"
    type="danger"
    class="close-button"
    (onClick)="selectedItem = null"
  ></dx-button>

  <div class="custom-list-item read">
    <div class="text">
      <div class="title">{{ selectedItem.DuyuruBaslik }}</div>
      <div [innerHTML]="safeHtmlContent"></div>
    </div>
  </div>
</div>



<!-- 📋 Ana Bildirim Paneli (dx-list içeriyor) -->
<div
  *ngIf="genBildirimValue.value === 'Duyuru'"
  class="panel"
  [ngClass]="{'bildirim-header': genBildirimValue.visible == false}"
  id="panel"
  #panel
>
  <ng-container class="main-container">
    <div id="data" #data class="data-wrapper">
      <div class="data-part border default-background">
        <div class="tabpanel-demo">
          <div class="content default-card">
            <div class="m-3">
              <span class="header-info-text">{{ genBildirimValue.text }}</span>
<dx-toolbar class="mb-4">
                <dxi-item
    location="after"
    widget="dxButton"
    locateInMenu="never"

    [options]="{
      icon: 'close',
      stylingMode: 'contained',
      type: 'danger',
      hint: 'Kapat',
      onClick: handleCancelClick
    }"
  ></dxi-item>
              </dx-toolbar>
              <dx-list
                class="dx-list-f"
                [dataSource]="dataSource"
                selectionMode="single"
                (onItemClick)="onItemClick($event)"
                height="100%"
              >
                <div *dxTemplate="let item of 'item'">
                  <div
                    class="notification-item"
                    [ngClass]="{ read: item.OkunduLogEh === 'E', unread: item.OkunduLogEh === 'H' }"
                  >
                    <div class="icon">
                      <i class="dx-icon dx-icon-notification"></i>
                    </div>
                    <div class="text">
                      <div class="title">{{ item.DuyuruBaslik }}</div>
                      <div class="message">{{ item.DuyuruOzet }}</div>
                      <div class="date">{{ item.YayinBaslangicTarih | date: 'dd.MM.yyyy' }}</div>
                    </div>
                  </div>
                </div>
              </dx-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
</ng-container>

